import * as React from "react";
import { DiseaseAdminModel, DiseaseFilterSettingsModel, DiseaseGridModel, DiseaseForGridModel } from "../../../models/disease";
import DiseaseList from './diseaseList';
import DiseaseService from '../../../services/diseaseService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { DiseaseFilter } from './diseaseFilter';
import DiseaseAddEditDialog from './diseaseAddEditDialog';
import { Lang } from '../../../common/enums';
import { DiseaseContentModel } from '../../../models/disease/diseaseContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./diseasesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  diseases: Array<DiseaseForGridModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentDisease: DiseaseAdminModel;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  diseaseSettings: DiseaseFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 20;

class DiseaseContainer extends React.Component<IProps, IState> {
  diseaseService = new DiseaseService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      diseases: new Array<DiseaseForGridModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentDisease: new DiseaseAdminModel(),
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      diseaseSettings: new DiseaseFilterSettingsModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllMedicines(this.state.from, this.state.numberOfRows);
  }

  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      let disease = new DiseaseAdminModel();
      let contentList = new Array<DiseaseContentModel>(0);

      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new DiseaseContentModel();
        content.langId = parseInt(Lang[k]);
        content.diseaseName = '';
        content.diseaseDesc = '';
        contentList.push(content);
      });

      disease.diseaseContent = contentList;
      this.setcurrentDisease(disease);
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.diseaseService.getDisease(id)
        .then(
          (data: DiseaseAdminModel) => {
            this.setcurrentDisease(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getManufacturer = (id) => {
    this.diseaseService.getDisease(id)
      .then(
        (data: DiseaseAdminModel) => {
          this.setcurrentDisease(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getManufacturer(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteMedicine(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.diseaseService.deleteDisease(id)
      .then(
        data => {
          this.getAllMedicines(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentDisease: DiseaseAdminModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentDisease.diseaseId) { // Add
      this.diseaseService.addDisease(currentDisease)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentDisease(new DiseaseAdminModel());
            this.getAllMedicines(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentDisease(new DiseaseAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.diseaseService.editDisease(currentDisease.diseaseId, currentDisease)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentDisease(new DiseaseAdminModel());
            this.getAllMedicines(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentDisease(new DiseaseAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllMedicines(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.diseaseService.getAllDiseases(from, numberOfRows, this.state.diseaseSettings).then(
      (data: DiseaseGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          diseases: data.diseases,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setcurrentDisease(medicine: DiseaseAdminModel) {
    this.setState({ currentDisease: { ...medicine } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllMedicines(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.diseaseService.getAllDiseases(initFrom, numberOfRows, settings).then(
      (data: DiseaseGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          diseases: data.diseases,
          diseaseSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { diseases, isLoading, error } = this.state;

    return (
      <div>

        <h3>Diseases</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <DiseaseAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentDisease={this.state.currentDisease}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
                </button>
        </div>

        <DiseaseFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        <DiseaseList
          diseases={diseases}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteMedicine(this.state.currentDisease.diseaseId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentDisease && this.state.currentDisease.diseaseContent
            && this.state.currentDisease.diseaseContent.length > 0 ? this.state.currentDisease.diseaseContent.map(r => r.diseaseName).join(' / ') : null}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default DiseaseContainer;